import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  Form,
  Spinner,
} from "reactstrap";
import { FILES_URL } from "helpers/url_helper";
import { changePassword, updateProfilePicture } from "helpers/fakebackend_helper";
import heic2any from "heic2any";

const UserProfile = () => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  document.title = "Profile | CurbDash";

  const [fullName, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dre, setDre] = useState(1);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [pwdState, setPwdState] = useState("idle"); // idle | loading | done
  const [picState, setPicState] = useState("idle"); // idle | loading | done

  useEffect(() => {
    setFullname(user.full_name);
    setEmail(user.email);
    setDre(user.dre);
    setPhoneNumber(user.phone_number);
  }, []);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    const currentPassword = e.target.currentPassword.value;
    const newPassword = e.target.newPassword.value;
    const confirmPassword = e.target.confirmPassword.value;

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      setSuccess("");
      return;
    }

    setPwdState("loading");
    try {
      await changePassword(user.token, {
        old_password: currentPassword,
        new_password: newPassword,
      });
      setPwdState("done");
      setSuccess("Password changed successfully.");
      setError("");
    } catch (err) {
      setPwdState("idle");
      setError(err.message || "Password update failed.");
      setSuccess("");
    }

    setTimeout(() => setPwdState("idle"), 2000);
  };

  // const handlePictureUpload = async (e) => {
  //   e.preventDefault();
  //   const file = e.target.profilePicture.files[0];
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append("picture", file);

  //   setPicState("loading");
  //   try {
  //     const res = await updateProfilePicture(user.token, formData);
  //     const updatedUser = { ...user, picture: res.data };
  //     localStorage.setItem("authUser", JSON.stringify(updatedUser));
  //     setPicState("done");
  //     setSuccess("Profile picture updated successfully.");
  //     setError("");
  //   } catch (err) {
  //     setPicState("idle");
  //     setError(err.message || "Profile picture update failed.");
  //     setSuccess("");
  //   }

  //   setTimeout(() => setPicState("idle"), 2000);
  // };
  const handlePictureUpload = async (e) => {
    e.preventDefault();
    const file = e.target.profilePicture.files[0];
    if (!file) return;

    let finalFile = file;

    if (file.name.toLowerCase().endsWith(".heic")) {
      try {
        const blob = await heic2any({ blob: file, toType: "image/jpeg" });
        finalFile = new File([blob], file.name.replace(/\.heic$/i, ".jpg"), { type: "image/jpeg" });
      } catch (err) {
        setError("HEIC conversion failed.");
        return;
      }
    }

    const formData = new FormData();
    formData.append("picture", finalFile);

    setPicState("loading");
    try {
      const res = await updateProfilePicture(user.token, formData);
      const updatedUser = { ...user, picture: res.data };
      localStorage.setItem("authUser", JSON.stringify(updatedUser));
      setPicState("done");
      setSuccess("Profile picture updated successfully.");
      setError("");
    } catch (err) {
      setPicState("idle");
      setError(err.message || "Profile picture update failed.");
      setSuccess("");
    }

    setTimeout(() => setPicState("idle"), 2000);
  };


  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg="12">
            {error && <Alert color="danger">{error}</Alert>}
            {success && <Alert color="success">{success}</Alert>}

            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="mr-3">
                    <img
                      src={user.picture ? FILES_URL + user.picture : "https://placehold.co/50"}
                      alt=""
                      className="avatar-md rounded-circle img-thumbnail"
                    />
                  </div>
                  <div className="flex-grow-1 align-self-center ms-3">
                    <div className="text-muted">
                      <h5>{fullName}</h5>
                      <p className="mb-0">{email}</p>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="6">
            <Card>
              <CardBody>
                <Form onSubmit={handlePasswordChange}>
                  <div className="form-group mb-3">
                    <Label>Current Password</Label>
                    <Input type="password" name="currentPassword" required />
                  </div>
                  <div className="form-group mb-3">
                    <Label>New Password</Label>
                    <Input type="password" name="newPassword" required />
                  </div>
                  <div className="form-group mb-3">
                    <Label>Confirm New Password</Label>
                    <Input type="password" name="confirmPassword" required />
                  </div>
                  <div className="text-center mt-4">
                    <Button type="submit" color={pwdState === "done" ? "success" : "dark"} disabled={pwdState === "loading"}>
                      {pwdState === "loading" && <Spinner size="sm" className="me-2" />}
                      {pwdState === "done" ? "Done" : "Change Password"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>

          <Col lg="6">
            <Card>
              <CardBody>
                <Form onSubmit={handlePictureUpload}>
                  <div className="form-group">
                    <Label className="form-label">Headshot Picture</Label>
                    <Input type="file" name="profilePicture" accept="image/*" />
                  </div>
                  <div className="text-center mt-4">
                    <Button type="submit" color={picState === "done" ? "success" : "dark"} disabled={picState === "loading"}>
                      {picState === "loading" && <Spinner size="sm" className="me-2" />}
                      {picState === "done" ? "Done" : "Update Picture"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserProfile;